export default "__VITE_ASSET__0bfb32f6__"